// Central API base URL for the admin dashboard.
// Override at build time with REACT_APP_API_URL (e.g. http://localhost:3001 for local backend).
export const API_BASE =
  process.env.REACT_APP_API_URL || "https://le-corpus-backend-production.up.railway.app";

export default API_BASE;
